import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../store';
import CircleProgressButton from '../../../buttons/CircleProgressButton';
import AudioIcon from '@mui/icons-material/MusicNoteRounded';
import { appOperations } from '../../../../App/store';
import ColoredSnackbarConstants from '../../../misc/ColoredSnackbar/ColoredSnackbarConstants';
import { AUDIO_UPLOAD_SUPPORTED_FORMATS } from '../CreatePageConstants';
import { validateAudioUpload } from '../helpers';

const styles = theme => ({
    fileInput: {
        display: 'none'
    }
});

class SettingsPanelAudioButton extends React.Component {
    render() {
        const { classes, audioPreparing, audioAnalyzing, savingInProgress, className } = this.props;

        return (
            <>
                <input
                    type='file'
                    accept={AUDIO_UPLOAD_SUPPORTED_FORMATS.join(',')}
                    id="audio-input"
                    className={classes.fileInput}
                    onChange={(e) => this.onAudioFileChange(e.target.files[0])}
                    ref={input => this.inputElement = input}
                />
                <CircleProgressButton
                    variant='outlined'
                    color='inherit'
                    size='small'
                    startIcon={<AudioIcon />}
                    onClick={this.onUploadAudioClick}
                    component='span'
                    disabled={savingInProgress || audioPreparing || audioAnalyzing}
                    loading={savingInProgress || audioPreparing || audioAnalyzing}
                    className={className}
                >
                    Upload Audio
                </CircleProgressButton>
            </>
        );
    }

    onUploadAudioClick = () => {
        const { savingInProgress, isVideoExportsQueued, showCriticalOperationProgressWarning } = this.props;

        if (savingInProgress) {
            showCriticalOperationProgressWarning();
            return;
        }

        if (isVideoExportsQueued())
            return;
       
        this.inputElement.click();
    }


    rejectAudioUploading = () => {
        const { setProperty } = this.props;
        setProperty("audioPreparing", false);
        document.getElementById('audio-input').value = '';
    }

    onAudioFileChange = (file) => {
        if (!file)
            return;

        const { applyNewAudioFile, videoSettingsId, setProperty, userSubscriptionType, showMessage } = this.props;
        setProperty("audioPreparing", true);

        validateAudioUpload(file, userSubscriptionType).then(() => {
            applyNewAudioFile(videoSettingsId, file);
        }).catch((message) => {
            showMessage(message, ColoredSnackbarConstants.SNACKBAR_WARNING);
            this.rejectAudioUploading();
        });
    }
}

const mapStateToProps = (state) => {
    const { audioPreparing, audioAnalyzing } = state.create;
    const { id: videoSettingsId } = state.createPreview.present.videoSettings;
    const { subscriptionType: userSubscriptionType } = state.app.accountDetails;
    const { savingInProgress } = state.create.videoSavingState;

    return {
        audioPreparing,
        audioAnalyzing,
        videoSettingsId,
        userSubscriptionType,
        savingInProgress
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    const applyNewAudioFile = (videoId, file) => dispatch(createActions.applyNewAudioFile(videoId, file));
    const isVideoExportsQueued = () => dispatch(createActions.isVideoExportsQueued());
    const showMessage = (message, variant) => dispatch(appOperations.openSnack(message, variant));
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());

    return {
        setProperty,
        applyNewAudioFile,
        showMessage,
        isVideoExportsQueued,
        showCriticalOperationProgressWarning
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SettingsPanelAudioButton, styles));